import { inject } from 'vue'

export function useLang(content: object) {
  const lang: string = inject('lang') ?? 'nl'
  return content[lang]
}
